import {
  Button,
  Div,
  H3,
  Modal,
  P,
  PropsModal,
  lightTheme,
} from '@vgrubs/components';
import { MenuPriceCustomizationV2Response } from 'components/src/types/menu.types';
import { Dispatch, SetStateAction } from 'react';

export const DeleteCustomPriceModal = ({
  deleteModal,
  closeModal,
  setCustomizedPrices,
}: PropsModal & {
  deleteModal: MenuPriceCustomizationV2Response | null;
  setCustomizedPrices: Dispatch<
    SetStateAction<MenuPriceCustomizationV2Response[]>
  >;
}) => {
  const handleDeletePrices = (e: { stopPropagation: () => void }) => {
    e.stopPropagation();
    setCustomizedPrices((prev) =>
      prev.filter((price) => price.provider !== deleteModal?.provider)
    );
    closeModal?.();
  };

  return (
    <Modal
      isOpen={!!deleteModal}
      closeModal={closeModal}
      logo={false}
      zIndex={111}
      overlayBorderRadius={30}
    >
      <H3 $mb="24" $color={lightTheme.primary}>
        Are you sure
      </H3>
      <P $mb="40">
        Are you sure you want to remove custom price for this provider?
      </P>

      <Div $flex $gap="16px">
        <Button onClick={handleDeletePrices} $w="100%" $selected>
          Remove
        </Button>
        <Button $selected $gray $w="100%" onClick={() => closeModal?.()}>
          Cancel
        </Button>
      </Div>
    </Modal>
  );
};
